import { useState } from "react";
import "./footerV2.scss";

import SalesEnquiry from "../SalesEnquiry/SalesEnquiry";
import Careers from "../Careers/Careers";

import {
  fb,
  linkedin,
  twitter,
  youtube,
  instagram,
  ColorLogo,
  locationIcon,
  messageIcon,
  geryDownArrow,
} from "../../images";
import { Link, NavLink } from "react-router-dom";
import Accordion from "react-bootstrap/Accordion";

const footerLinks = [
  {
    id: 1,
    title: "Products",
    links: [
      {
        id: 1,
        title: "PURO Cotton Yarns",
        link: "/products/cotton-yarn",
        type: "link",
      },
      {
        id: 2,
        title: "Polyester Yarns",
        link: "/products/polyester-yarn",
        type: "link",
      },
      {
        id: 3,
        title: "Yarns for Technical Textile",
        link: "/products/yarn-for-technical-textile",
        type: "link",
      },
      {
        id: 4,
        title: "Reviro Yarn",
        link: "/products/reviro",
        type: "link",
      },
      {
        id: 5,
        title: "Born Dyed Yarn",
        link: "/products/born-dyed",
        type: "link",
      },
      {
        id: 6,
        title: "Dry Cool",
        link: "/products/dry-cool",
        type: "link",
      },
      {
        id: 7,
        title: "Stretch Yarn",
        link: "/products/stretch-yarn",
        type: "link",
      },
      {
        id: 8,
        title: "CDP Yarn",
        link: "/products/cationic-dyeable-polyester",
        type: "link",
      },
    ],
  },
  {
    id: 2,
    title: "About Us",
    links: [
      {
        id: 1,
        title: "Our Company",
        link: "/about-us/the-company",
        type: "link",
      },
      {
        id: 2,
        title: "Our Team",
        link: "/about-us/our-team",
        type: "link",
      },
      {
        id: 3,
        title: "Our Journey",
        link: "/about-us/our-journey",
        type: "link",
      },
    ],
  },
  {
    id: 3,
    title: "Our Setup",
    links: [
      {
        id: 1,
        title: "Infrastructure",
        link: "/our-setup/infrastructure",
        type: "link",
      },
      {
        id: 2,
        title: "Tech in Textile",
        link: "/our-setup/tech-in-textile",
        type: "link",
      },
      {
        id: 3,
        title: "Certifications",
        link: "/our-setup/certifications",
        type: "link",
      },
      {
        id: 4,
        title: "Quality and R+D",
        link: "/our-setup/quality-and-r+d",
        type: "link",
      },
    ],
  },
  {
    id: 4,
    title: "Other Links",
    links: [
      {
        id: 1,
        title: "Investors",
        link: "/investor-relations",
        type: "link",
      },
      {
        id: 2,
        title: "Newsroom",
        link: "/newsroom",
        type: "link",
      },
      {
        id: 3,
        title: "Blogs",
        link: "/blogs",
        type: "link",
      },
      {
        id: 4,
        title: "Contact Us",
        link: "/contact-us",
        type: "link",
      },
      {
        id: 4,
        title: "Careers",
        link: "/privacy-policy",
        type: "modal",
        modal: "careers",
      },
    ],
  },
];

const FooterV2 = () => {
  const [activeModal, setActiveModal] = useState(null);
  const currentYear = new Date();

  const handleModalOpen = (modalName) => {
    setActiveModal(modalName);
  };

  const handleModalClose = () => {
    setActiveModal(null);
  };

  return (
    <>
      {activeModal === "careers" && (
        <Careers onRequestClose={handleModalClose} />
      )}

      <footer className="footerV2_container">
        <div className="wrapper">
          <div className="footerV2_row">
            <div className="footerV2_column">
              <div className="contact_wrapper">
                <Link to="/">
                  <img
                    src={ColorLogo}
                    alt="Sanathan Textiles Logo"
                    width={391}
                    height={71}
                    className="sanathan_logo"
                  />
                </Link>

                <div className="contact_info address_info">
                  <img
                    src={locationIcon}
                    alt="location"
                    width={60}
                    height={60}
                    className="contact_icon"
                  />
                  <p className="contact_text">
                    D15, trade world, kamala mill compound, senapati bapat Marg,
                    lower Parel West Mumbai, Maharashtra 400013.
                  </p>
                </div>
                <div className="contact_info">
                  <img
                    src={messageIcon}
                    alt="location"
                    width={60}
                    height={60}
                    className="contact_icon"
                  />
                  <a href="mailto:sales@sanathan.com" rel="noreferrer">
                    <p className="contact_text">sales@sanathan.com</p>
                  </a>
                </div>
              </div>
            </div>

            <div className="footerV2_column">
              <div className="link_container link_container_desk">
                {footerLinks?.map((item, index) => (
                  <div className="link_wrapper">
                    <p className="link_title">{item.title}</p>
                    <ul className="link_list">
                      {item?.links?.map((link, index) => (
                        <li className="link_list_item">
                          {link.type === "modal" ? (
                            <button
                              type="button"
                              className="footer_link_btn"
                              onClick={() => handleModalOpen(link.modal)}
                            >
                              {link.title}
                            </button>
                          ) : (
                            <NavLink to={link.link}>{link.title}</NavLink>
                          )}
                        </li>
                      ))}
                    </ul>
                  </div>
                ))}
              </div>

              <div className="link_container link_container_mob">
                <Accordion defaultActiveKey="1">
                  {footerLinks?.map((item, index) => (
                    <Accordion.Item
                      eventKey={`${item.id}`}
                      key={item.id}
                      className="link_wrapper"
                    >
                      <Accordion.Header>
                        <p className="link_title">{item.title}</p>
                        <img
                          src={geryDownArrow}
                          width={12}
                          height={6}
                          alt="down arrow"
                          className="down_arrow"
                        />
                      </Accordion.Header>
                      <Accordion.Body>
                        <ul className="link_list">
                          {item?.links?.map((link, index) => (
                            <li className="link_list_item">
                              {link.type === "modal" ? (
                                <button
                                  type="button"
                                  className="footer_link_btn"
                                  onClick={() => handleModalOpen(link.modal)}
                                >
                                  {link.title}
                                </button>
                              ) : (
                                <NavLink to={link.link}>{link.title}</NavLink>
                              )}
                            </li>
                          ))}
                        </ul>
                      </Accordion.Body>
                    </Accordion.Item>
                  ))}
                </Accordion>
              </div>
            </div>
          </div>
        </div>

        <div className="footerV2_bottom">
          <div className="wrapper">
            <div className="copy_right_container">
              <p className="copy_right_text copy_text">
                Copyright ©{currentYear.getFullYear()} Sanathan Textiles
              </p>

              <ul className="social_icons_wrapper">
                <li className="social_link">
                  <a
                    href="https://youtube.com/channel/UCt9TLtYA5ayira8PRzXx9ig"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <img
                      src={youtube}
                      alt="youtube logo"
                      loading="lazy"
                      className="social_icon youtube_icon"
                    />
                  </a>
                </li>
                <li className="social_link">
                  <a
                    href="https://www.instagram.com/sanathantextiles/"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <img
                      src={instagram}
                      alt="instagram logo"
                      loading="lazy"
                      className="social_icon insta_icon"
                    />
                  </a>
                </li>
                <li className="social_link">
                  <a
                    href="https://www.facebook.com/Sanathan-Textiles-204062499635407"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <img
                      src={fb}
                      alt="facebook logo"
                      loading="lazy"
                      className="social_icon fb_icon"
                    />
                  </a>
                </li>
                <li className="social_link">
                  <a
                    href="https://in.linkedin.com/company/sanathan-textiles-private-limited"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <img
                      src={linkedin}
                      alt="linkedin logo"
                      loading="lazy"
                      className="social_icon linkedin_icon"
                    />
                  </a>
                </li>
              </ul>

              <p className="copy_right_text crafted_text">
                <a
                  href="https://www.togglehead.in/"
                  target="_blank"
                  rel="noreferrer"
                >
                  Crafted by Togglehead
                </a>
              </p>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
};

export default FooterV2;
